import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import FormSelect from '../components/FormSelect.js';
import ChartArea from '../components/ChartArea.js';

const formatStatValue = (item) => {
	if (item.TYPE === 'W') {
		if (item.TYPEID === 1) {
			return `${item.CNT} x ${item.WEIGHT} kg`;
		}

		return item.TIMESECS;
	}

	return `${item.MYWEIGHT} kg`;
};

export default function Stat({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [offset, setOffset] = useState(0);
	const [data, setData] = useState([]);
	const [dataStat, setDataStat] = useState([]);
	const [dataGraph, setDataGraph] = useState([]);
	const [workoutId, setWorkoutId] = useState(-1);
	const [workoutName, setWorkoutName] = useState('Moje hmotnost');
	const [loadedCnt, setLoadedCnt] = useState(0);

	const workoutRef = useRef(null);

	useEffect(() => {
		getData(workoutId, offset);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData(workoutId, prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const getData = (workoutId, offset) => {
		setLoading(true);

		post('getListStatistics', {WORKOUTID: workoutId, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setDataStat(res.data.data_stats);
				} else {
					setDataStat((prevRows) => {
						const updatedRows = [...prevRows, ...res.data.data_stats];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.data_stats.length);
				setData(res.data.data);
				setDataGraph(res.data.data_graph);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const setWokout = (val) => {
		setWorkoutId(val.ID);
		setWorkoutName(val.NAME);
		setOffset(0);

		getData(val.ID, 0);
	};

	const accentColor = dataGraph?.color || '#8acaa3';
	const graphPointCount = dataGraph?.data?.length || 0;

	const groupedStats = dataStat.reduce((groups, item) => {
		const groupKey = item.CRDT_D || `group_${item.ID}`;
		const existingGroup = groups.find((group) => group.key === groupKey);

		if (!existingGroup) {
			groups.push({
				key: groupKey,
				title: item.CRDT_DS,
				type: item.TYPE,
				totalWeight: item.TYPE === 'W' && item.TYPEID === 1 ? item.CNT * item.WEIGHT : 0,
				items: [item],
			});
			return groups;
		}

		existingGroup.items.push(item);

		if (item.TYPE === 'W' && item.TYPEID === 1) {
			existingGroup.totalWeight += item.CNT * item.WEIGHT;
		}

		return groups;
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />

				<div className={`page stat-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<section className="stat-page__panel stat-page__panel--filter">
						<FormSelect type="text" label="Vyber cvik" value={workoutId} valueLabel={workoutName} setValue={setWokout} options={data} showNone={false} ref={workoutRef} error="" />
					</section>

					<section className="stat-page__panel stat-page__panel--chart" style={{'--stat-accent': accentColor}}>
						<div className="stat-page__panel-head">
							<div>
								<div className="stat-page__panel-kicker">Graf vývoje</div>
								<h2 className="stat-page__panel-title">{workoutName}</h2>
							</div>
							<div className="stat-page__panel-total">{graphPointCount}</div>
						</div>

						{graphPointCount > 0 ? (
							<div className="stat-page__chart-wrap">
								<ChartArea className="stat-page__chart" data={dataGraph.data} labels={dataGraph.labels} color={accentColor} linesColor={'#c8d4ce'} variant="glass" height="100%" />
							</div>
						) : (
							<div className="stat-page__empty">Pro vybraný přehled zatím není k dispozici žádný graf.</div>
						)}
					</section>

					<div className="stat-page__shell">
						{groupedStats.length > 0 ? (
							groupedStats.map((group) => (
								<section className="stat-page__panel stat-page__panel--group" key={group.key}>
									<div className="stat-page__panel-head">
										<div>
											<div className="stat-page__panel-kicker">Den záznamu</div>
											<h2 className="stat-page__panel-title">{group.title}</h2>
										</div>
										<div className="stat-page__panel-total">
											{group.type === 'W' && group.totalWeight > 0 ? `${group.totalWeight.toLocaleString()} kg` : `${group.items.length}`}
										</div>
									</div>

									<div className="stat-page__rows">
										{group.items.map((item) => (
											<div className="stat-page__row" key={item.ID}>
												<div className="stat-page__row-date">{item.CRDTS}</div>
												<div className="stat-page__row-value">{formatStatValue(item)}</div>
											</div>
										))}
									</div>
								</section>
							))
						) : (
							<div className="stat-page__empty">Zatím nejsou uložené žádné statistické záznamy.</div>
						)}
					</div>

					<div className="stat-page__load-more">
						{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
							<button type="button" className="stat-page__load-button" onClick={() => loadNext()}>
								Načíst další
							</button>
						) : (
							<span className="stat-page__load-note">Byly načteny všechny záznamy</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
